
import { setTheme } from "@microsoft/shifts-experiences-shared";
import { getTeamsThemeType } from "@microsoft/shifts-ui-core";
import * as microsoftTeams from "@microsoft/teams-js";

import { setThemeName } from "./store";

/**
 * Returns theme identifier that needs to be used in a project.
 * @param theme The theme identifier.
 * @returns Project styles class that needs to be used.
 */
export function getShiftThemeName(theme: string): string {
    const useWindowA11ySystemStyles = isWindowA11yThemeEnabled();
    if (useWindowA11ySystemStyles) {
        return `shifts_theme_windowsHighContrast`;
    }

    return `shifts_theme_${theme}`;
}

/**
 * Initialize the theme.
 * @param theme The theme identifier.
 */
export function initializeThemes(theme: string): void {
    document.documentElement.className = getShiftThemeName(theme);
    setThemeName(theme);
    setTheme(getTeamsThemeType(theme));

    // TODO: Update TeamsHostContainer to register this theme handler in "initialize" method.
    microsoftTeams.registerOnThemeChangeHandler((teamsThemeName: string) => {
        document.documentElement.className = getShiftThemeName(teamsThemeName);
        setThemeName(teamsThemeName);
        setTheme(getTeamsThemeType(teamsThemeName));
    });
}

const isWindowA11yThemeEnabled = (): boolean => {
    const a11yThemeEnabled = matchMedia('(forced-colors: active)');
    if (a11yThemeEnabled.matches) {
        return true;
    }
    return false;
};
